import React, { Component } from 'react'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import Typography from 'material-ui/Typography'
import SendIcon from 'material-ui-icons/Send'
import TextField from 'material-ui/TextField'
import analytics from '../../utils/analytics'
import Dialog, { DialogContent } from 'material-ui/Dialog'
import type { DialogProps } from 'material-ui/Dialog'
import AppBar from 'material-ui/AppBar'

type Props = DialogProps & {
  onClose: Function
}

type State = {
  feedback: string,
  missingFeedback: boolean
}

class FeedbackDialog extends Component<Props, State> {
  state = {
    feedback: '',
    missingFeedback: false
  }

  feedbackInput = undefined

  handleClickSend = e => {
    e.preventDefault()

    const { onClose } = this.props
    const { feedback } = this.state

    if (feedback) {
      analytics.track('Feedback Sent', {
        Description: this.state.feedback
      })

      this.setState({
        feedback: ''
      })
      onClose()
    } else {
      this.setState({
        missingFeedback: true
      })
      this.feedbackInput.focus()
    }
  }

  handleFeedbackChange = (e: SyntheticInputEvent<>) => {
    this.setState({
      feedback: e.target.value,
      missingFeedback: !e.target.value
    })
  }

  setRef = input => this.feedbackInput = input

  render() {
    const {
      onClose,
      ...rest
    } = this.props

    const {
      missingFeedback
    } = this.state

    return (
      <Dialog
        {...rest}
        onClose={onClose}
        fullScreen
      >
        <form noValidate onSubmit={this.handleClickSend}>
          <AppBar position='static'>
            <Toolbar>
              <IconButton
                color='inherit'
                onClick={onClose}
                aria-label='Close'
              >
                <CloseIcon />
              </IconButton>

              <Typography variant='title' color='inherit' className='flex-auto'>
                Send Feedback
              </Typography>

              <IconButton color='inherit' className='flex' type='submit'>
                <SendIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent classes={{ root: 'mt3' }}>
            <TextField
              helperText={missingFeedback && 'A description is required'}
              error={missingFeedback}
              onChange={this.handleFeedbackChange}
              inputRef={this.setRef}
              InputProps={{
                disableUnderline: !missingFeedback
              }}
              placeholder='Share your ideas'
              autoFocus
              multiline
              fullWidth
              rowsMax='10'
            />
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

export default FeedbackDialog



// WEBPACK FOOTER //
// ./src/components/FeedbackDialog/FeedbackDialog.js